<script setup lang="ts">
import { computed, ref } from 'vue'
import { regions, regions as reduxRegions } from '@/onenetwork/constants/onenetwork.regions.const'
import ObjectPicker from '@/onenetwork/components/object_picker/ObjectPicker.vue'
import WardComp from '@/onenetwork/components/filter/WardComp.vue'
import { Icon } from '@iconify/vue'

interface Props {
  regions: Array<any>
}
const props = defineProps<Props>()
const regionsData = computed(() => {
  return props.regions
})

const _regions = regions.map((item: any) => {
  return {
    id: item.id,
    name: item.name,
    select: false
  }
})

const regionlevel1 = ref<any>(null)
const regionlevel2 = ref<any>(null)
const _wards = ref<any>([])

const getRegionLevel2 = (regionId: string) => {
  const region = regions.find((item: any) => item.id === regionId)
  if (!region?.children?.length) return []
  return region.children.map((item: any) => ({
    ...item,
    select: false,
    level1: { id: region.id, name: region.name }
  }))
}

const handleUpdateRegion1 = (vals: any) => {
  console.log(vals, regions)
  regionlevel1.value = vals;
  regionlevel2.value = null;
  if(vals.length > 0) {
    _wards.value = getRegionLevel2(vals[0].id)
  }
}

const handleUpdateRegion2 = (vals: any) => {
  console.log(vals, regions)
  regionlevel2.value = vals;
}

const emit = defineEmits(['selected'])

const handleSubmit = () => {
  const ward = regionlevel2.value
  if (!ward?.length) return
  emit('selected', ward)
}
</script>

<template>
  <div class="flex gap-2 mb-1">
    <div class="flex flex-col w-full">
      <ObjectPicker
        placeholder="Chọn tỉnh thành"
        :multiple="false"
        v-model="regionlevel1"
        key_field="id"
        display_field="name"
        query-field="name"
        api-url="https://dummyjson.com/users"
        :data="_regions"
        :modelValue="regionlevel1"
        @update:selected="handleUpdateRegion1"
      />
    </div>
    <div class="flex flex-col w-full">
      <ObjectPicker
        placeholder="Chọn phường xã"
        :multiple="false"
        v-model="regionlevel2"
        key_field="id"
        display_field="name"
        query-field="name"
        api-url="https://dummyjson.com/users"
        :data="_wards"
        :modelValue="regionlevel2"
        :display-comp="WardComp"
        @update:selected="handleUpdateRegion2"
      />
    </div>
    <div class="flex flex-col">
      <button @click="handleSubmit" type="button" class="add">
        <Icon icon="ph:plus-fill" />
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.add{
  font-size: 24px;
  color: #3f9800;
  cursor: pointer;
  &:hover{
    color: #1f2937;
  }
}
</style>
